import React from "react"
import Styles from "./ForHealthCoachPricesStyle.module.styl"
import translate from "../../../../../translation/translator"
import keys from "../../../../../translation/keys"

const ForHealthCoachPrices = ({ locale }) => {
  return (
    <div className={Styles.wrapper}>
      <h2 className={Styles.section_title}>
        {translate(keys.HLTH_COACH_PRICE_TALK_IN_NUM, locale)}
      </h2>
      <p className={Styles.section_description}>
        {translate(keys.HLTH_COACH_PRICE_TIN_TEXT, locale)}{" "}
      </p>
      <div className={Styles.holder}>
        <div className="row no-gutters">
          <div className="col-lg-3 col-sm-6">
            <div className={Styles.item}>
              <p>{translate(keys.HLTH_COACH_PRICE_PRECENT_I, locale)}</p>
              <p>{translate(keys.HLTH_COACH_PRICE_I_TEXT, locale)}</p>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6">
            <div className={Styles.item}>
              <p>{translate(keys.HLTH_COACH_PRICE_PRECENT_II, locale)}</p>
              <p>{translate(keys.HLTH_COACH_PRICE_II_TEXT, locale)}</p>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6">
            <div className={Styles.item}>
              <p>{translate(keys.HLTH_COACH_PRICE_PRECENT_III, locale)}</p>
              <p>{translate(keys.HLTH_COACH_PRICE_III_TEXT, locale)}</p>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6">
            <div className={Styles.item}>
              <p>{translate(keys.HLTH_COACH_PRICE_PRECENT_IV, locale)}</p>
              <p>{translate(keys.HLTH_COACH_PRICE_IV_TEXT, locale)} </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ForHealthCoachPrices
